var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AppMainScreen"},[_c('Navbar',{attrs:{"me":_vm.me}}),(!_vm.isMobile)?_c('Sidebar',{attrs:{"me":_vm.me}}):_vm._e(),_c('div',{staticClass:"Container",class:{ mobile: _vm.isMobile }},[_c('Transition',{attrs:{"name":"main-router","mode":"out-in"}},[_c('RouterView',{attrs:{"me":_vm.me}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }